import React, { useEffect, useState } from 'react';
import getContentGiftCardCall from '@kfc-global/react-shared/redux/Actions/GiftCardAction';
import { resetPurchaseAction } from '@kfc-global/react-shared/redux/Actions/GiftCardPurchaseAction';
import { useSelector, useDispatch } from 'react-redux';
import { StartOrderComponent } from 'organisms/StartOrderComponent';
import { Footer } from 'organisms/FooterComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from 'components/homePageContainer/Constants/homePageContainerConstants';
import { Header } from 'organisms/HeaderComponent';
import GiftCardContainer from 'organisms/GiftCard/Container/GiftCardContainer';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  isEmptyObject,
  getGiftCardData,
  isMobileDevice,
} from 'common/utilities/utils';
import { getCmsClient } from 'common/utilities/cmsClient';
import { getContent, getMarketConfigContent } from 'common/utilities/content';
import { StructureData } from 'organisms/StructureDataComponent';
import { GIFTCARDS } from 'common/constants/SharedConstants';

const GiftcardComponent = props => {
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const tenantReducer = useSelector(data => data.tenantReducer);
  const giftCardPageGlobal = tenantReducer?.componentOptions?.web?.giftCardPageGlobal;
  const dispatch = useDispatch();

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  let userParams = useSelector(data => data.appStateReducer.userStatus);

  useEffect(() => {
    !giftCardPageGlobal && dispatch(getMarketConfigContent(tenantReducer));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, tenantReducer?.country]);

  useEffect(() => {
    !giftCardPageGlobal && dispatch(getContent(userParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userParams]);

  useEffect(() => {
    !giftCardPageGlobal &&
      dispatch(
        getContentGiftCardCall({
          object: getCmsClient(),
          contentFull: {
            content_type: 'staticLandingPage',
            'fields.page': 'Gift Card',
            include: '5',
          },
        }),
      );
    dispatch(resetPurchaseAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedFooterData = null;
  let segmentedGiftCardData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const allReducerData = useSelector(data => {
    return {
      homePageContent: data.contentReducer.response || null,
      marketPageContent: data.marketConfigReducer.response || null,
      tenantReducerContent: data.tenantReducer || null,
      giftCardContent: data.giftCardReducer || null,
    };
  });

  if (
    allReducerData?.marketPageContent?.headerData &&
    allReducerData?.tenantReducerContent &&
    allReducerData?.homePageContent &&
    isEmptyObject(allReducerData.giftCardContent)
  ) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const { header = {}, footer = {} } = allReducerData.marketPageContent.headerData;
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
    segmentedGiftCardData = getGiftCardData(allReducerData.giftCardContent);
  }

  return (
    <React.Fragment>
      {(isEmptyObject(segmentedMarketingData) && !giftCardPageGlobal && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      <StructureData page={GIFTCARDS} />
      {!giftCardPageGlobal && (
        <StartOrderComponent
          contentData={{
            segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
            contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
          }}
          userParams={userParams}
        />
      )}
      {isEmptyObject(segmentedGiftCardData) && (
        <GiftCardContainer contentData={segmentedGiftCardData} giftCardPageGlobal={giftCardPageGlobal} location = {props?.location}/>
      )}
      {(isEmptyObject(segmentedFooterData) && !giftCardPageGlobal && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
    </React.Fragment>
  );
};

export default GiftcardComponent;
